module.exports = __webpack_public_path__ + "img/lotto_online.2dc35a6e.png";